import { render, staticRenderFns } from "./xiaofei.vue?vue&type=template&id=70e74c18"
import script from "./xiaofei.vue?vue&type=script&lang=js"
export * from "./xiaofei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports